import { render, staticRenderFns } from "./AddTarif.vue?vue&type=template&id=e6080fc8&"
import script from "./AddTarif.vue?vue&type=script&lang=js&"
export * from "./AddTarif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports